import React from "react"
import PropTypes from "prop-types"
//i18n
import { withTranslation } from "react-i18next"

//Import Breadcrumb
import { PageContent, CustomBreadcrumb } from "components/Common"

import UserProfiles from "./UserProfies"
import { ModuleIds } from "constant"

// const RESOURCE = ModuleIds.User

const UserProfilesContainer = ({ t }) => {
  const titleTag = `User Profile`
  return (
    <PageContent title={titleTag}>
      {/* PageTitle */}
      <CustomBreadcrumb
        breadcrumbItem={t("User Profile")}
        // resource={RESOURCE}
      />

      {/* Page Body */}
      <UserProfiles />
    </PageContent>
  )
}

UserProfilesContainer.propTypes = {
  t: PropTypes.any,
}

export default withTranslation(["userPage"])(UserProfilesContainer)
